const list = {
  path: 'systemSet',
  component: resolve => require(['@/pages/admin/platform/systemSet'], resolve)
}

export default list
